module.exports = "<div class=\"cd-card cd-card--fixed\">\r\n  <header class=\"cd-card__header\">\r\n    <span>Repeat Members</span>\r\n    <span class=\"cd-card__hint\">{{ hint }}</span>\r\n  </header>\r\n  <div class=\"cd-grid\">\r\n    <ag-grid-angular class=\"compact-menu\" [gridOptions]=\"grid\"></ag-grid-angular>\r\n  </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/complaints/complaints-dashboard/components/dashboard-repeat-members/dashboard-repeat-members.component.html
// module id = 2417
// module chunks = 66